/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-28 20:16:30
 * @LastEditors: liuziwei
 * @Description: 首页 - 天降弹窗 - 券组件
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-item-container" style="{{couponBg}}">
    <view wx:if="{{couponData.discount}}" class="left-area">
      <text class="discount" style="{{discountColor}}">{{ couponData.discount }}</text>
      <text class="unit" style="{{unitColor}}">折</text>
    </view>
    <view class="right-area">
      <text wx:if="{{couponData.name}}" class="name" style="{{nameColor}}">
        {{ couponData.name }}
      </text>
      <text wx:if="{{couponData.remark}}" class="remark" style="{{remarkColor}}">
        {{ couponData.remark }}
      </text>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      },
      couponTheme: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      // 券背景
      couponBg() {
        return `background: ${this.couponTheme?.couponBg}`
      },
      // 价格颜色
      discountColor() {
        return `color: ${this.couponTheme?.discountColor ?? '#FF591D'}`
      },
      // 单位颜色
      unitColor() {
        return `color: ${this.couponTheme?.unitColor ?? '#F5420D'}`
      },
      // 券名称颜色
      nameColor() {
        return `color: ${this.couponTheme?.nameColor ?? '#6E3A22'}`
      },
      // 券释义颜色
      remarkColor() {
        return `color: ${this.couponTheme?.remarkColor ?? '#888'}`
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-item-container
    width 100%
    height 60px
    background #fff
    margin-bottom 6px
    border-radius 10px
    display flex
    align-items center
    position relative
    box-sizing border-box
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 3px, #000 0) -68px -5px
    mask radial-gradient(circle at calc(100% - 94px) 5px, transparent 3px, #000 0) -68px -5px
    .left-area
      width 73px
      display flex
      flex-shrink 0
      align-items baseline
      justify-content center
      .discount
        font-family Barlow Semi Condensed
        font-size 32px
        font-weight 400
        line-height 26px
      .unit
        font-family PingFang SC
        font-size 15px
        font-weight 400
        line-height 15px
      .tag
        background #222
        padding 2px 8px
        position absolute
        top 0
        font-family PingFangSC-Medium
        font-size 9px
        font-weight normal
        line-height 9px
        border-radius 0 0 12px 12px / 0 0 20px 20px
        clip-path polygon(0 0, 100% 0, 92% 100%, 8% 100%)
        color #fff
    .right-area
      height 48px
      padding 0 9px
      display flex
      overflow hidden
      flex-direction column
      justify-content center
      border-left 1px dashed rgba(254, 152, 53, 0.2)
      .name, .remark
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        font-family PingFang SC
      .name
        font-size 16px
        font-weight 500
        line-height 16px
      .remark
        font-size 11px
        font-weight normal
        margin-top 5px
        line-height 11px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
